import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import cx from 'classnames';

import ChecklistTaskItem from '../ChecklistTaskItem';
import ChecklistActiveFilterTags from '../ChecklistActiveFilterTags';
import ChecklistEmptyState from '../ChecklistEmptyState';

import './ChecklistTaskList.less';

const ChecklistTaskList = props => {
  const { checklistTasksGroups, checklistTasks, className, noFilterResults, clearFilters } = props;

  const renderResults = () => {
    if (noFilterResults) {
      return (
        <ChecklistEmptyState
          className="task-list__emptyState hidden-md hidden-lg"
          buttonCopy="Clear Filters"
          onClick={clearFilters}
        />
      );
    }

    return checklistTasksGroups.map(group => (
      <div className="task-list-section" key={group.label}>
        <div className="task-list-section__header">{group.label}</div>
        <div className="task-list-section__tasks">
          {map(group.taskIds, taskId => {
            const task = checklistTasks[taskId] || {};
            return (
              <ChecklistTaskItem
                key={task.id}
                title={task.title}
                id={task.id}
                checklistTemplateName={task.checklist_template_name}
                addedByUserId={!task.checklist_template_task_id && task.created_by_user_object_id}
                isComplete={Boolean(task.completed_at)}
                sponsoredUrl={task.sponsored_url}
              />
            );
          })}
        </div>
      </div>
    ));
  };

  return (
    <div className={cx('checklist__taskList-container', className)}>
      <ChecklistActiveFilterTags />
      {renderResults()}
    </div>
  );
};

ChecklistTaskList.propTypes = {
  checklistTasksGroups: PropTypes.arrayOf(PropTypes.object),
  checklistTasks: PropTypes.shape({}),
  className: PropTypes.string,
  noFilterResults: PropTypes.bool,
  clearFilters: PropTypes.func,
};

ChecklistTaskList.defaultProps = {
  checklistTasksGroups: [],
  checklistTasks: {},
  className: '',
  noFilterResults: false,
};

export default ChecklistTaskList;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTaskList/ChecklistTaskList.jsx